class SlideImage extends HTMLElement{
    constructor(){
        super()
        this.init()
    }
    init () {
        var containerDom = this.querySelector('.my-slider');
        tns({
            container: containerDom,
            "responsive": {
              "575" : {
                "items": 1
              },
              "576": {
                "items": 2
              },
              "768": {
                "items": 3
              }
            },
            "gutter": 24,
            "swipeAngle": false,
            "speed": 400,
            "mouseDrag": true,
            loop: false,
            "controlsContainer": ".slide-nav",
            nav: false,
          });
    }
}

customElements.define('slide-image', SlideImage)